import api from './client'


export const gukApi = {
  getEvents: (params) => api.get('/events', { params }),
  getEvent: (eventId) => api.get(`/events/${eventId}`),
  createEvent: (data) => api.post('/events', data),
  updateEvent: (eventId, data) => api.put(`/events/${eventId}`, data),
  deleteEvent: (eventId) => api.delete(`/events/${eventId}`),
  openRegistration: (eventId) => api.post(`/events/${eventId}/open-registration`),
  getEventResults: (eventId) => api.get(`/events/${eventId}/results`)
}
